
let trim = (x) => {
  let value = String(x);
  return value.replace(/^\s+|\s+$/gm, '');
};


let removeEmpty = (obj) => {
  Object.keys(obj).forEach(key => obj[key] == null && delete obj[key]);
  return obj;
};


let sortObj = (obj) => {
  return Object.keys(obj)
    .sort()
    .reduce(function (result, key) {
      result[key] = obj[key];
      return result;
    }, {});
};


export {
  removeEmpty,
  sortObj
};
